interface InputItems {
  name: string;
  label: object;
  jsonKey: string;
  optionName: string;
  selections: object[] | null;
  value: number;
  visible: boolean;
  calcType?: string;
}

export const inputItems: InputItems[] = [
  {
    name: "keijou",
    label: {
      ja: "形状名",
      en: "Box Type"
    },
    jsonKey: "boxType",
    optionName: "box_type_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "keijou_option",
    label: {
      ja: "形状オプション",
      en: "Box Type Option"
    },
    jsonKey: "keijouOption",
    optionName: "keijouOption",
    selections: [
      {
        id: 0,
        yesNo: {
          ja: "なし",
          en: "None"
        }
      },
      {
        id: 1,
        yesNo: {
          ja: "あり",
          en: "With cover"
        }
      }
    ],
    value: 0,
    visible: true
  },
  {
    name: "rot",
    label: {
      ja: "数量",
      en: "Quantity"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 50,
    visible: true
  },
  {
    name: "nouki",
    label: {
      ja: "納期",
      en: "Delivery Time"
    },
    jsonKey: "deliveryDateType",
    optionName: "delivery_date_type_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "l_",
    label: {
      ja: "サイズ① W",
      en: "Size ① W"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 20,
    visible: true
  },
  {
    name: "w_",
    label: {
      ja: "サイズ② D",
      en: "Size ② D"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 30,
    visible: true
  },
  {
    name: "d_",
    label: {
      ja: "サイズ③ H",
      en: "Size ③ H"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 40,
    visible: true
  },
  {
    name: "ninni1",
    label: {
      ja: "サイズ④",
      en: "Size ④"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "ninni2",
    label: {
      ja: "サイズ⑤",
      en: "Size ⑤"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "ninni3",
    label: {
      Ja: "",
      en: ""
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 500,
    visible: false
  },
  {
    name: "ninni4",
    label: {
      Ja: "",
      en: ""
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 500,
    visible: false
  },
  {
    name: "innsatu_men",
    label: {
      ja: "印刷面",
      en: "Color"
    },
    jsonKey: "printDimensionType",
    optionName: "print_dimension_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "yousi",
    label: {
      ja: "用紙",
      en: "Paper"
    },
    jsonKey: "paperType",
    optionName: "paper_type_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "hyomen_kako",
    label: {
      ja: "表面加工",
      en: "Coating"
    },
    jsonKey: "coatingType",
    optionName: "coating_type_name",
    selections: null,
    value: 4,
    visible: true
  },
  {
    name: "pb_yousi_iro",
    label: {
      ja: "色紙色",
      en: "PaperColor"
    },
    jsonKey: "paperColorIro",
    optionName: "color_name",
    selections: null,
    value: 0,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "pb_yousi_tanto",
    label: {
      ja: "タント色",
      en: "PaperColor:Tanto"
    },
    jsonKey: "paperColorTanto",
    optionName: "color_name",
    selections: null,
    value: 33,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "pb_yousi_viotope",
    label: {
      ja: "ビオトープ色",
      en: "PaperColor:Biotope"
    },
    jsonKey: "paperColorBiotope",
    optionName: "color_name",
    selections: null,
    value: 0,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "teikei",
    label: {
      ja: "定型",
      en: "FixedForm"
    },
    jsonKey: "fixFormOption",
    optionName: "fixFormOption",
    selections: [
      {
        id: 0,
        yesNo: {
          ja: "いいえ",
          en: "YES"
        }
      },
      {
        id: 1,
        yesNo: {
          ja: "はい",
          en: "NO"
        }
      }
    ],
    value: 0,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "fix_form_reccomend_id",
    label: {
      ja: "定型サイズ",
      en: "PeprBugFixedForm"
    },
    jsonKey: "peprBugFixedForm",
    optionName: "name",
    selections: null,
    value: 4,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "soko_ball",
    label: {
      ja: "底ボール",
      en: "under ball"
    },
    jsonKey: "paperBugSokoBall",
    optionName: "paperBugSokoBall_name",
    selections: [
      {
        id: 0,
        yesNo: {
          ja: "いいえ",
          en: "NO"
        }
      },
      {
        id: 1,
        yesNo: {
          ja: "はい",
          en: "YES"
        }
      }
    ],
    value: 0,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "tesage",
    label: {
      ja: "手提げ紐",
      en: "paperBugHolder"
    },
    jsonKey: "paperBugHolder",
    optionName: "holder_name",
    selections: null,
    value: 1,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "egara",
    label: {
      ja: "絵柄",
      en: "Design Pattern"
    },
    jsonKey: "paperBugEgara",
    optionName: "paperBugEgara_name",
    selections: [
      {
        id: 0,
        yesNo: {
          ja: "べたなし",
          en: "NO"
        }
      },
      {
        id: 1,
        yesNo: {
          ja: "べたあり",
          en: "YES"
        }
      },
      {
        id: 2,
        yesNo: {
          ja: "未定",
          en: "unknown"
        }
      }
    ],
    value: 0,
    visible: true,
    calcType: "paperBug"
  },
  {
    name: "kousei_houhou",
    label: {
      ja: "校正",
      en: "Proofing"
    },
    jsonKey: "optionConfigurationMethod",
    optionName: "configuration_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "haku_name",
    label: {
      ja: "箔押し",
      en: "Foil Stamping"
    },
    jsonKey: "optionFoilStampingCost",
    optionName: "foil_stamping_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "haku_osi_size1",
    label: {
      ja: "箔押し W",
      en: "Foil Stamping W"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 500,
    visible: true
  },
  {
    name: "haku_osi_size2",
    label: {
      ja: "箔押し D",
      en: "Foil Stamping D"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 500,
    visible: true
  },
  {
    name: "sikisai_chosei",
    label: {
      ja: "色彩調整",
      en: "Color Adjustment"
    },
    jsonKey: "optionColorAdjustment",
    optionName: "color_adjustment_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "sample",
    label: {
      ja: "サンプル",
      en: "Sample"
    },
    jsonKey: "optionSampleCost",
    optionName: "sample_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "kigata",
    label: {
      ja: "前回抜き型",
      en: "Existing Wooden Mold"
    },
    jsonKey: "kigata",
    optionName: "kigata",
    selections: [
      {
        id: 0,
        yesNo: {
          ja: "なし",
          en: "none"
        }
      },
      {
        id: 1,
        yesNo: {
          ja: "あり",
          en: "use"
        }
      }
    ],
    value: 0,
    visible: true
  },
  {
    name: "kigata_hozon",
    label: {
      ja: "抜き型保存",
      en: "Keep Wooden Mold"
    },
    jsonKey: "optionKeepWoodenMoldCost",
    optionName: "keep_wooden_mold_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "keisai",
    label: {
      ja: "Web掲載",
      en: "Share on Web"
    },
    jsonKey: "optionShareOnWebCost",
    optionName: "share_on_web_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "nounyu",
    label: {
      ja: "納入先",
      en: "Delivery Area"
    },
    jsonKey: "commonDeliveryCost",
    optionName: "delivery_area",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "konpou",
    label: {
      ja: "梱包方法",
      en: "Pack Method"
    },
    jsonKey: "commonPackingCost",
    optionName: "packing_name",
    selections: null,
    value: 0,
    visible: true
  },
  {
    name: "konpou_suryou",
    label: {
      ja: "梱包数量（小分け時）",
      en: "Packing Quantity"
    },
    jsonKey: "",
    optionName: "",
    selections: null,
    value: 500,
    visible: true
  }
];

export const labels: any = {
  ja: {
    detailCommon: "詳細 共通スペック  ",
    detailScenario: "詳細 シナリオ別スペック",
    calcScenario: "シナリオ別コスト／売価",
    scenarioName: "シナリオ名",
    lastInput: "最後に送信した入力内容を復元する",
    sendButton: "送信する",
    pasteTextLink: "テキストリンクを貼り付け",
    generateTextLink: "テキストリンクを生成する",
    copied: "コピーしました!"
  },
  en: {
    detailCommon: "Common Spec",
    detailScenario: "Spec by Scenario",
    calcScenario: "Cost/Price by Scenario",
    scenarioName: "Scenario Name",
    lastInput: "Recall Previous Spec",
    sendButton: "Send",
    pasteTextLink: "Paste Text Link",
    generateTextLink: "Generate Text Link",
    copied: "Copied!"
  }
};
const hacoStorage: Storage = localStorage;
const language =
  hacoStorage.getItem("language") && hacoStorage.getItem("language") === "ja"
    ? "ja"
    : "en";
export let expectedLabels: any;
export let resultLabels: any;
let specScenarioResult: any;
if (language === "ja") {
  specScenarioResult = {
    calcPrintableSizeW: "印刷可能サイズW",
    calcPrintableSizeD: "展印刷可能サイズD",
    calcImposition: "面付数",
    calcSerialNumber: "通し数",
    calcSerialBuffer: "予備",
    calcSerialWithBuffer: "通し数（予備込）",
    calcPageNumber: "ページ数"
  };
  expectedLabels = {
    otherCost: "その他",
    isMargin: "マージン有無",
    customTotalCost: "トータルコスト",
    totalScenarioOptionCost: "オプション合計"
  };

  resultLabels = {
    Common: {
      calcNumberOfColors: "色数",
      calcBoxW: "展開図サイズW",
      calcBoxD: "展開図サイズD",
      calcDevelopmentDrawing: "展開図面積",
      calcDevelopmentWooden: "木型代（展開図1面）",
      paperWight: "用紙重量（gsm）",
      calcOverallWeight: "全体重量（kg）",
      calcNumberOfPakingBoxes: "梱包箱数",
      calcSubDivisionNumber: "小分け数",
      calcDeliveryCost: "送料"
    },

    specScenarioResult: specScenarioResult,

    Results: {
      specScenarioResult: specScenarioResult,

      printerResult: {
        costType: "印刷　計算タイプ",
        calcFixedCost: "印刷　固定/ミニマムコスト",
        calcFunctionableCost: "印刷　変動コスト"
      },
      coaterResult: {
        costType: "表面加工 計算タイプ",
        fixedCost: "表面加工　固定/ミニマムコスト",
        functionableCost: "表面加工　変動コスト"
      },
      dieCutResult: {
        costType: "打ち抜き　計算タイプ",
        fixedCost: "打ち抜き　固定/ミニマムコスト",
        functionableCost: "打ち抜き　変動コスト"
      },
      GlueResult: {
        costType: "貼り　計算タイプ",
        fixedCost: "貼り　固定/ミニマムコスト",
        functionableCost: "貼り　変動コスト"
      },
      OtherResult: {
        paperCost: "用紙",
        inkCost: "インク",
        woodenModelCost: "木型",
        packingCost: "梱包",
        otherCost: expectedLabels.otherCost
      },
      paperBugOrientedResult: {
        paperBugHolder: "提げ手",
        underBall: "底ボール"
      },
      customResult: {
        isMargin: "マージン有無",
        totalCost: "カスタムコスト"
      },
      scenarioOption: {
        optionPackingCost: "梱包オプション",
        optionConfigureCost: "オプション　校正",
        optionFoilStampCost: "オプション　箔押し",
        optionColorAdjustment: "オプション　色彩調整",
        optionSampleCost: "オプション　サンプル",
        optionWoodenCost: "オプション　前回抜き型",
        optionKeepWoodenMoldCost: "オプション　抜き型保存",
        optionShareOnWebCost: "オプション　web掲載",
        customImargin: "カスタム(マージンあり)",
        otherCost: expectedLabels.otherCost,
        totalScenarioOptionCost: expectedLabels.totalScenarioOptionCost
      },

      totalResult: {
        productCostTotal: "コスト合計",
        fixedCost: "固定マージン",
        fixedTotal: "売価（固定マージン）",
        marginRate: "マージン率",
        marginTotal: "売価（マージン率）",
        costGrandTotal: "小計",
        customEmargin: "カスタム(マージンなし)",
        totalScenarioOptionCost: expectedLabels.totalScenarioOptionCost,
        costGrandTotalTax: "消費税",
        calcDeliveryCost: "配送料",
        costGrandTotalWithTaxWithDeliveryCost: "合計"
      }
    },
    scenarioName: "シナリオ名"
  };
} else {
  specScenarioResult = {
    calcPrintableSizeW: "Printable Area W",
    calcPrintableSizeD: "Printable Area D",
    calcImposition: "Imposition Number",
    calcSerialNumber: "Sheet Volume",
    calcSerialBuffer: "Buffer",
    calcSerialWithBuffer: "Sheet Volume(incl. buffer)",
    calcPageNumber: "Impression"
  };
  expectedLabels = {
    otherCost: "Others",
    isMargin: "isMargin",
    customTotalCost: "Custom Total Cost",
    totalScenarioOptionCost: "Option Total"
  };

  resultLabels = {
    Common: {
      calcNumberOfColors: "Number of color",
      calcBoxW: "Flat View Dimension W",
      calcBoxD: "Flat View Dimension D",
      calcDevelopmentDrawing: "Flat View Size (㎠)",
      calcDevelopmentWooden: "Cost of Die Cutter (1up)",
      paperWight: "Paper Weight (gsm)",
      calcOverallWeight: "Weight (kg)",
      calcNumberOfPakingBoxes: "Number of pack",
      calcSubDivisionNumber: "Number of Wrap",
      calcDeliveryCost: "Shipping Fee"
    },

    specScenarioResult: specScenarioResult,

    Results: {
      specScenarioResult: specScenarioResult,

      printerResult: {
        costType: "Print Type",
        calcFixedCost: "Print Fixed/Minimum Cost",
        calcFunctionableCost: "Print Variable Cost"
      },
      coaterResult: {
        costType: "Coating Type",
        fixedCost: "Coating Fixed/Minimum Cost",
        functionableCost: "Coating Variable Cost"
      },
      dieCutResult: {
        costType: "Die-cutting Type",
        fixedCost: "Die-cutting Fixed/Minimum Cost",
        functionableCost: "Die-cutting Variable Cost"
      },
      GlueResult: {
        costType: "Glue Type",
        fixedCost: "Glue Fixed/Minimum Cost",
        functionableCost: "Glue Variable Cost"
      },
      OtherResult: {
        paperCost: "Paper",
        inkCost: "Ink",
        woodenModelCost: "Wooden Mold",
        packingCost: "Pack",
        otherCost: expectedLabels.otherCost
      },
      paperBugOrientedResult: {
        paperBugHolder: "paperBugHolder",
        underBall: "underBall"
      },
      customResult: {
        isMargin: "Has Margin",
        totalCost: "Custom Cost"
      },
      scenarioOption: {
        optionPackingCost: "Optional Pack",
        optionConfigureCost: "Option Proof",
        optionFoilStampCost: "Option Foil Stamp",
        optionColorAdjustment: "Option Color Adjustment",
        optionSampleCost: "Option Sample",
        optionWoodenCost: "Option Existing Wooden Mold",
        optionKeepWoodenMoldCost: "Option Keep Wooden Mold",
        optionShareOnWebCost: "Option Share on Web",
        customImargin: "Custom Including Margin",
        otherCost: expectedLabels.otherCost,
        totalScenarioOptionCost: expectedLabels.totalScenarioOptionCost
      },

      totalResult: {
        productCostTotal: "Total Cost",
        fixedCost: "Fixed Margin",
        fixedTotal: "Price with Fixed Margin",
        marginRate: "Price with Margin Rate",
        marginTotal: "Margin Total",
        costGrandTotal: "Sub Total",
        customEmargin: "Custom Excluding Margin",
        totalScenarioOptionCost: expectedLabels.totalScenarioOptionCost,
        costGrandTotalTax: "Tax",
        calcDeliveryCost: "Delivery Fee",
        costGrandTotalWithTaxWithDeliveryCost: "Grand Total"
      }
    },
    scenarioName: "シナリオ名"
  };
}
